module.exports = __webpack_public_path__ + "static/img/strip.56d999e.png";


//////////////////
// WEBPACK FOOTER
// ./static/strip.png
// module id = uONl
// module chunks = 457